import styled from 'styled-components';

export const RowButtonWrapper = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
  margin-left: auto;
`;
